import { ErrorHandler, Injectable } from '@angular/core';
import { isChunkLoadError, reloadOnceForStaleAssets } from '../utils/chunk-load.util';
import { showBlankShellRecovery } from '../utils/shell-recovery.util';

/**
 * A post-login exception can detach the root view and leave app-root empty.
 * Chunk failures reload once. Anything else gets a reload panel only when
 * neither the shell nor the login card survived.
 */
@Injectable()
export class ShellErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    console.error(error);
    if (isChunkLoadError(error) && reloadOnceForStaleAssets()) {
      return;
    }
    setTimeout(() => showBlankShellRecovery(), 0);
  }
}
